import axios from 'axios';

import {
  ResponseObj,
  ConsultaColetivaPostFormData,
  ConsultaColetivaPutFormData,
  ConsultaColetivaIniciarFormData,
  ConsultaColetivaCancelarFormData,
  ConsultaColetivaFinalizarFormData,
  ConsultasColetivasPaginatedData,
  ConsultaColetivaAdicionaFormData,
} from '../../../back/src/types';
import { ConsultaColetiva } from '../../../back/src/entity/ConsultaColetiva';

const consultaColetiva = async (
  consultaColetivaId: number,
): Promise<ResponseObj<ConsultaColetiva>> => {
  const res = await axios.get<ResponseObj<ConsultaColetiva>>(
    `consultas_coletivas/${consultaColetivaId}`,
  );
  return res.data;
};

const criaConsultaColetiva = async (
  formData: ConsultaColetivaPostFormData,
): Promise<ResponseObj<ConsultaColetiva>> => {
  const res = await axios.post<ResponseObj<ConsultaColetiva>>('consultas_coletivas', formData);
  return res.data;
};

const alteraConsultaColetiva = async (
  formData: ConsultaColetivaPutFormData,
): Promise<ResponseObj<ConsultaColetiva>> => {
  const res = await axios.put<ResponseObj<ConsultaColetiva>>('consultas_coletivas', formData);
  return res.data;
};

const adicionaPacienteConsultaColetiva = async (
  formData: ConsultaColetivaAdicionaFormData,
): Promise<ResponseObj<ConsultaColetiva>> => {
  const res = await axios.put<ResponseObj<ConsultaColetiva>>(
    'consultas_coletivas/adicionar',
    formData,
  );
  return res.data;
};

const buscaConsultasColetivas = async (
  queryObj: Object = {},
): Promise<ResponseObj<ConsultasColetivasPaginatedData>> => {
  const res = await axios.get<ResponseObj<ConsultasColetivasPaginatedData>>(
    'consultas_coletivas',
    { params: queryObj },
  );
  return res.data;
};

const iniciaConsultaColetiva = async (
  formData: ConsultaColetivaIniciarFormData,
): Promise<ResponseObj<ConsultaColetiva>> => {
  const res = await axios.put<ResponseObj<ConsultaColetiva>>(
    'consultas_coletivas/iniciar',
    formData,
  );
  return res.data;
};

const finalizaConsultaColetiva = async (
  formData: ConsultaColetivaFinalizarFormData,
): Promise<ResponseObj<ConsultaColetiva>> => {
  const res = await axios.put<ResponseObj<ConsultaColetiva>>(
    'consultas_coletivas/finalizar',
    formData,
  );
  return res.data;
};

const cancelaConsultaColetiva = async (
  formData: ConsultaColetivaCancelarFormData,
): Promise<ResponseObj<ConsultaColetiva>> => {
  const res = await axios.put<ResponseObj<ConsultaColetiva>>(
    'consultas_coletivas/cancelar',
    formData,
  );
  return res.data;
};

export default {
  consultaColetiva,
  criaConsultaColetiva,
  alteraConsultaColetiva,
  adicionaPacienteConsultaColetiva,
  buscaConsultasColetivas,
  iniciaConsultaColetiva,
  cancelaConsultaColetiva,
  finalizaConsultaColetiva,
};
